<template>
  <div class="p-4">
    <div class="dashboard">Carriers</div>
    <div class="mb-4">
      <button class="dark-button" @click="syncCarriers" :disabled="syncing">
        {{ syncing ? "Syncing..." : "Sync from ShipStation" }}
      </button>
    </div>

    <div v-if="loading" class="text-gray-500">Loading carriers...</div>

    <div v-if="!loading && carriers.length === 0" class="text-gray-500">
      No carriers found. Click "Sync from ShipStation" to import them.
    </div>

    <div
      v-for="carrier in carriers"
      :key="carrier.id"
      class="mb-4 border rounded-lg overflow-hidden"
    >
      <div
        class="flex items-center justify-between p-3 bg-gray-100 cursor-pointer"
        @click="toggleCarrier(carrier.id)"
      >
        <div>
          <span class="font-semibold">{{ carrier.name || carrier.code }}</span>
          <span v-if="carrier.nickname" class="text-gray-500 ml-2"
            >({{ carrier.nickname }})</span
          >
          <span
            class="text-xs ml-2 px-2 py-0.5 rounded"
            :class="
              carrier.primary
                ? 'bg-green-200 text-green-800'
                : 'bg-gray-200 text-gray-600'
            "
          >
            {{ carrier.code }}
          </span>
        </div>
        <div class="flex items-center gap-3 text-sm text-gray-500">
          <span
            v-if="carrier.balance !== null && carrier.balance !== undefined"
          >
            Balance: ${{ Number(carrier.balance).toFixed(2) }}
          </span>
          <span
            >{{ carrier.services ? carrier.services.length : 0 }} services</span
          >
          <span class="text-lg">{{
            expandedCarriers[carrier.id] ? "▾" : "▸"
          }}</span>
        </div>
      </div>

      <div
        v-if="
          expandedCarriers[carrier.id] &&
            carrier.services &&
            carrier.services.length > 0
        "
      >
        <table class="w-full text-sm">
          <thead class="bg-gray-50">
            <tr>
              <th class="text-left p-2">Service</th>
              <th class="text-left p-2">Code</th>
              <th class="text-center p-2">Domestic</th>
              <th class="text-center p-2">International</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="svc in carrier.services"
              :key="svc.uuid"
              class="border-t"
            >
              <td class="p-2">{{ svc.name }}</td>
              <td class="p-2 text-gray-500 font-mono text-xs">
                {{ svc.code }}
              </td>
              <td class="p-2 text-center">{{ svc.domestic ? "✓" : "—" }}</td>
              <td class="p-2 text-center">
                {{ svc.international ? "✓" : "—" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        v-if="
          expandedCarriers[carrier.id] &&
            (!carrier.services || carrier.services.length === 0)
        "
        class="p-3 text-gray-400 text-sm"
      >
        No services found for this carrier.
      </div>
    </div>
  </div>
</template>

<script>
import CarriersApi from "@/api/Carriers";

export default {
  name: "CarriersPage",
  data() {
    return {
      carriers: [],
      loading: false,
      syncing: false,
      expandedCarriers: {}
    };
  },
  mounted() {
    this.loadCarriers();
  },
  methods: {
    async loadCarriers() {
      this.loading = true;
      try {
        const res = await CarriersApi.getCarriers();
        this.carriers = res.data || [];
      } catch {
        this.$toast.open({
          message: "Error loading carriers",
          type: "error",
          position: "top-right"
        });
      } finally {
        this.loading = false;
      }
    },
    async syncCarriers() {
      this.syncing = true;
      try {
        const res = await CarriersApi.syncFromShipStation();
        const data = res.data || {};
        this.$toast.open({
          message: `Synced ${data.carriersSynced ||
            0} carriers and ${data.servicesSynced || 0} services`,
          type: "success",
          position: "top-right"
        });
        await this.loadCarriers();
      } catch {
        this.$toast.open({
          message: "Error syncing carriers from ShipStation",
          type: "error",
          position: "top-right"
        });
      } finally {
        this.syncing = false;
      }
    },
    toggleCarrier(id) {
      this.$set(this.expandedCarriers, id, !this.expandedCarriers[id]);
    }
  }
};
</script>
